var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVdieoLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_2993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9224 14.187C17.8725 13.2914 13.7729 14.6788 12.5139 17.4693C12.3648 17.7998 11.8733 18.8894 11.7502 19.1621C10.4848 21.9669 12.1978 25.0448 15.5762 26.0368C18.4875 26.8916 21.6855 25.9187 23.324 23.8386C23.5871 23.5048 23.8097 23.1424 23.9847 22.7545",
    stroke: "#7B79A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1407 18.1369C22.1907 19.0325 26.2902 17.6451 27.5492 14.8546C27.6983 14.5241 28.1899 13.4345 28.3129 13.1618C29.5784 10.357 27.8654 7.27911 24.4869 6.28709C21.5756 5.43226 18.3777 6.4052 16.7391 8.48533C16.4762 8.8192 16.2534 9.18153 16.0784 9.56942",
    stroke: "#7B79A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_2993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 30.6172,
    fill: "white",
    transform: "matrix(0.411244 -0.911525 0.959492 0.281736 0 23.6997)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdieoLink);
export default __webpack_public_path__ + "static/media/vdieoLink.3fd2f268a4416649576f3757d20c25fc.svg";
export { ForwardRef as ReactComponent };